import React, { useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { useNewPassword } from '../../app/auth'
import { Button, Form, Spacer } from '@spritz-finance/ui'
import { FormContent } from '../AuthenticationStyled'
import { PublicLayoutHeader } from '../PublicLayout/Header'

interface NewPasswordFormValues {
    password: string
    confirmPassword: string
}

export const NewPasswordPage: React.VFC = () => {
    const { completeNewPassword, loading, error } = useNewPassword()

    const methods = useForm<NewPasswordFormValues>()

    useEffect(() => {
        if (!error) return
        methods.setError('password', error)
    }, [error, methods])

    const onSubmit: SubmitHandler<NewPasswordFormValues> = (data) => {
        completeNewPassword(data.password)
    }

    return (
        <>
            <PublicLayoutHeader
                title="Update your password"
                subtitle="Please create a new password for your use"
            />

            <Form<NewPasswordFormValues>
                onSubmit={onSubmit}
                width="auto"
                methods={methods}
            >
                <FormContent>
                    <Form.Input
                        name="password"
                        type="password"
                        placeholder="Password"
                        validation={{ required: true }}
                    />
                    <Form.Input
                        name="confirmPassword"
                        type="password"
                        placeholder="Confirm Password"
                        confirm="password"
                        confirmMessage="Passwords do not match"
                    />
                    <Button.CTA loading={loading} type="submit">
                        Set New Password
                    </Button.CTA>
                </FormContent>
            </Form>
            <Spacer height={48} />
        </>
    )
}
